import { Pipe, type PipeTransform } from '@angular/core';

/**
 * Pluralizes a word based on count value
 * Usage:
 *   count | qpxPlural: 'file'
 *   count | qpxPlural: 'box':'boxes'
 * Examples:
 *   {{ 0 | qpxPlural: 'file' }} => '0 files'
 *   {{ 1 | qpxPlural: 'file' }} => '1 file'
 *   {{ 5 | qpxPlural: 'file' }} => '5 files'
 *   {{ 2 | qpxPlural: 'box':'boxes' }} => '2 boxes'
 */
@Pipe({
    name: 'qpxPlural',
})
export class QpxPluralPipe implements PipeTransform {
    transform(
        count: number,
        singularWord: string,
        pluralWord?: string
    ): string {
        if (count === null || count === undefined) {
            return '';
        }

        const plural = pluralWord || `${singularWord}s`;
        return `${count} ${count === 1 ? singularWord : plural}`;
    }
}
